import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerimetreCranienComponent } from './perimetre-cranien/perimetre-cranien.component';
import { PerperimetreCranien60Component } from './perperimetre-cranien60/perperimetre-cranien60.component';

export enum PERIMETRE_CRANIEN_PROVIDERS_TOKEN {
  PERIMETRE_13_S_OLD_MALE,
  PERIMETRE_13_S_OLD_GIRL,
  PERIMETRE_60_M_OLD_MALE,
  PERIMETRE_60_M_OLD_GIRL,
}
export interface PreimetreChartProviderValue {
  label: string,
  values: Array<number>,
  borderColor: string
}
export const PREIMETRE_CRANIEN_CHART_PROVIDERS_DATA: Map<PERIMETRE_CRANIEN_PROVIDERS_TOKEN, Array<PreimetreChartProviderValue>> = new Map([
  [
    PERIMETRE_CRANIEN_PROVIDERS_TOKEN.PERIMETRE_60_M_OLD_MALE,
    [
      {
        label: 'P3',
        values:  [32.1, 35.1, 36.9, 38.3, 39.4, 40.4, 41.3, 42.1, 42.8, 43.4, 44.0, 44.5, 45.0, 45.4, 45.8, 46.2, 46.5, 46.8, 47.1, 47.3, 47.6, 47.8, 48.0, 48.2, 48.4, 48.6, 48.7, 48.9, 49.0, 49.1, 49.3, 49.4, 49.5, 49.6, 49.7, 49.8, 49.9, 49.9, 50.0, 50.1, 50.1, 50.2, 50.2, 50.3, 50.3, 50.3, 50.4, 50.4, 50.4, 50.4, 50.4, 50.4, 50.4, 50.4, 50.4, 50.4, 50.4, 50.4, 50.4],
        borderColor: '#ff6384', // Couleur pour P3
      },
      {
        label: 'P15',
        values: [33.1, 36.1, 37.9, 39.3, 40.4, 41.4, 42.3, 43.1, 43.8, 44.5, 45.1, 45.6, 46.1, 46.5, 46.9, 47.3, 47.6, 47.9, 48.2, 48.5, 48.7, 48.9, 49.1, 49.3, 49.5, 49.6, 49.8, 49.9, 50.0, 50.2, 50.3, 50.4, 50.5, 50.6, 50.7, 50.7, 50.8, 50.9, 50.9, 51.0, 51.0, 51.0, 51.1, 51.1, 51.1, 51.1, 51.2, 51.2, 51.2, 51.2, 51.2, 51.2, 51.2, 51.2, 51.2, 51.2, 51.2, 51.2, 51.2],
        borderColor: '#36a2eb', // Couleur pour P15
      },
      {
        label: 'P50',
        values: [34.5, 37.3, 39.1, 40.5, 41.6, 42.6, 43.5, 44.3, 45.0, 45.6, 46.2, 46.7, 47.2, 47.6, 48.0, 48.4, 48.7, 49.0, 49.3, 49.5, 49.8, 50.0, 50.2, 50.4, 50.6, 50.7, 50.9, 51.0, 51.1, 51.2, 51.3, 51.4, 51.5, 51.6, 51.7, 51.7, 51.8, 51.9, 51.9, 52.0, 52.0, 52.1, 52.1, 52.1, 52.2, 52.2, 52.2, 52.2, 52.2, 52.2, 52.2, 52.2, 52.2, 52.2, 52.2, 52.2, 52.2, 52.2, 52.2]
        ,
        borderColor: '#4bc0c0', // Couleur pour P50
      },
      {
        label: 'P85',
        values:   [35.8, 38.5, 40.3, 41.7, 42.9, 43.9, 44.9, 45.8, 46.5, 47.2, 47.8, 48.3, 48.8, 49.3, 49.7, 50.1, 50.4, 50.7, 51.0, 51.3, 51.5, 51.7, 51.9, 52.1, 52.3, 52.4, 52.6, 52.7, 52.8, 52.9, 53.0, 53.1, 53.2, 53.2, 53.3, 53.3, 53.4, 53.4, 53.4, 53.5, 53.5, 53.5, 53.5, 53.5, 53.5, 53.6, 53.6, 53.6, 53.6, 53.6, 53.6, 53.6, 53.6, 53.6, 53.6, 53.6, 53.6, 53.6, 53.6],
        
        borderColor: '#ffcd56', // Couleur pour P85
      },
      {
        label: 'P97',
        values: [36.9, 39.5, 41.3, 42.7, 43.9, 44.9, 45.8, 46.7, 47.5, 48.1, 48.7, 49.3, 49.8, 50.2, 50.6, 51.0, 51.3, 51.6, 51.9, 52.2, 52.4, 52.6, 52.8, 53.0, 53.2, 53.4, 53.5, 53.7, 53.8, 53.9, 54.0, 54.1, 54.2, 54.3, 54.3, 54.4, 54.4, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5, 54.5],
        borderColor: '#9966ff', // Couleur pour P97
      },
    ],
  ],
  [
    PERIMETRE_CRANIEN_PROVIDERS_TOKEN.PERIMETRE_60_M_OLD_GIRL,
    [
      {
        label: 'P3',
        values: [
          31.7, 34.3, 36, 37.2, 38.2, 39, 39.7, 40.4, 41, 41.3, 41.7, 42, 42.6, 42.9, 43.1, 43.3, 43.5, 43.6, 43.8, 44, 44.1, 44.3, 44.4, 44.6, 44.7, 44.8, 44.9, 45.1, 45.2, 45.3, 45.4, 45.5, 45.6, 45.7, 45.8, 45.9, 46, 46.1, 46.2, 46.3, 46.4, 46.5, 46.6, 46.7, 46.8, 46.9, 47, 47.1, 47.2, 47.3, 47.4, 47.5, 47.6, 47.7, 47.8, 47.9, 48, 48.1, 48.2, 48.3, 48.4
        ],
        borderColor: '#ff6384', // Couleur pour P3
      },
      {
        label: 'P15',
        values: [
          33.1, 35.3, 37, 38.2, 39.3, 40.1, 40.8, 41.5, 42, 42.4, 42.8, 43.2, 43.8, 44, 44.2, 44.4, 44.6, 44.8, 45, 45.1, 45.3, 45.5, 45.6, 45.8, 45.9, 46, 46.2, 46.3, 46.5, 46.6, 46.7, 46.8, 46.9, 47, 47.1, 47.2, 47.3, 47.4, 47.5, 47.6, 47.7, 47.8, 47.9, 48, 48.1, 48.2, 48.3, 48.4, 48.5, 48.6, 48.7, 48.8, 48.9, 49, 49.1, 49.2, 49.3, 49.4, 49.5, 49.6, 49.7
        ],
        borderColor: '#36a2eb', // Couleur pour P15
      },
      {
        label: 'P50',
        values: [
          33.9, 36.5, 38.3, 39.5, 40.6, 41.5, 42.2, 42.8, 43.4, 43.8, 44.3, 44.7, 45.2, 45.4, 45.7, 45.9, 46.1, 46.3, 46.5, 46.7, 46.9, 47.1, 47.2, 47.4, 47.5, 47.7, 47.8, 48, 48.1, 48.2, 48.3, 48.4, 48.5, 48.6, 48.7, 48.8, 48.9, 49, 49.1, 49.2, 49.3, 49.4, 49.5, 49.6, 49.7, 49.8, 49.9, 50, 50.1, 50.2, 50.3, 50.4, 50.5, 50.6, 50.7, 50.8, 50.9, 51, 51.1, 51.2, 51.3
        ],
        borderColor: '#4bc0c0', // Couleur pour P50
      },
      {
        label: 'P85',
        values: [
          35.1, 37.8, 39.5, 40.8, 41.9, 42.8, 43.5, 44.2, 44.7, 45.2, 45.6, 46, 46.6, 46.8, 47.1, 47.3, 47.5, 47.7, 47.9, 48.1, 48.3, 48.5, 48.6, 48.8, 48.9, 49.1, 49.2, 49.4, 49.5, 49.6, 49.7, 49.8, 49.9, 50, 50.1, 50.2, 50.3, 50.4, 50.5, 50.6, 50.7, 50.8, 50.9, 51, 51.1, 51.2, 51.3, 51.4, 51.5, 51.6, 51.7, 51.8, 51.9, 52, 52.1, 52.2, 52.3, 52.4, 52.5, 52.6
        ],
        borderColor: '#ffcd56', // Couleur pour P85
      },
      {
        label: 'P97',
        values: [
          36.1, 38.8, 40.5, 41.9, 43, 43.9, 44.6, 45.3, 45.9, 46.3, 46.8, 47.1, 47.7, 48, 48.2, 48.5, 48.7, 48.9, 49.1, 49.3, 49.5, 49.7, 49.8, 50, 50.1, 50.3, 50.4, 50.6, 50.7, 50.8, 50.9, 51, 51.1, 51.2, 51.3, 51.4, 51.5, 51.6, 51.7, 51.8, 51.9, 52, 52.1, 52.2, 52.3, 52.4, 52.5, 52.6, 52.7, 52.8, 52.9, 53, 53.1, 53.2, 53.3, 53.4, 53.5, 53.6, 53.7, 53.8
        ],
        borderColor: '#9966ff', // Couleur pour P97
      },
    ],
  ],
  // 13 seamine 

  [
    PERIMETRE_CRANIEN_PROVIDERS_TOKEN.PERIMETRE_13_S_OLD_MALE,
   [
    { 
      label: 'P3',
      values: [32.1,32.9,33.7,34.3,34.9,35.4,35.9,36.3,36.7,37,37.4,37.7,38,38.3],
      borderColor: '#ff6384'
    },
    {
      label: 'P15',
      values: [33.1,33.9,34.7,35.3,35.9,36.4,36.8,37.3,37.7,38,38.4,38.7,39,39.3],
      borderColor: '#36a2eb'
    },
    {
      label: 'P50',
      values: [34.5,35.2,35.9,36.5,37.1,37.6,38.1,38.5,38.9,39.2,39.6,39.9,40.2,40.5],
      borderColor: '#4bc0c0'
    },
    {
      label: 'P85',
      values: [35.8,36.4,37.1,37.7,38.3,38.8,39.3,39.7,40.1,40.5,40.8,41.1,41.4,41.7],
      borderColor: '#ffcd56'
    },
    {
      label: 'P97',
      values: [36.9,37.5,38.1,38.7,39.3,39.8,40.3,40.7,41.1,41.4,41.8,42.1,42.4,42.7],
      borderColor: '#9966ff'
    }
   ]
  ],
  [
    PERIMETRE_CRANIEN_PROVIDERS_TOKEN.PERIMETRE_13_S_OLD_GIRL,
   [
    { 
      label: 'P3',
      values: [31.7,32.4,33.1,33.7,34.2,34.6,35,35.4,35.7,36.1,36.4,36.7,36.9,37.2],
      borderColor: '#ff6384'
    },
    {
      label: 'P15',
      values: [32.7,33.3,34,34.6,35.2,35.6,36,36.4,36.8,37.1,37.4,37.7,38,38.2],
      borderColor: '#36a2eb'
    },
    
    {
      label: 'P50',
      values: [33.9,34.6,35.2,35.8,36.4,36.8,37.3,37.7,38,38.4,38.7,39,39.3,39.5],
      borderColor: '#4bc0c0'
    },
    {
      label: 'P85',
      values: [35.1,35.8,36.4,37,37.6,38.1,38.5,38.9,39.3,39.6,39.9,40.2,40.5,40.8],
      borderColor: '#ffcd56'
    },
    {
      label: 'P97',
      values: [36.1,36.7,37.4,38,38.6,39.1,39.5,39.9,40.3,40.6,41,41.3,41.6,41.9],
      borderColor: '#9966ff'
    }
   ]
  ],

])
@NgModule({
  declarations: [
    PerimetreCranienComponent,
    PerperimetreCranien60Component
  ],
  imports: [
    CommonModule
  ],
    providers: [
      {
        provide: 'PREIMETRE_CRANIEN_CHART_PROVIDERS_DATA',
        useValue: PREIMETRE_CRANIEN_CHART_PROVIDERS_DATA,
      }
    ],
    exports: [
      PerimetreCranienComponent,
      PerperimetreCranien60Component
    ]
})
export class PérimètreCrânienModule { }
